import React, { useMemo } from "react";
import { useParams } from "react-router-dom";

import { useDictionary } from "hooks";
import Helper from "./helpers";

import { HAPLO_COSTING_API } from "globals/constants";

import IntegrationComponent from "components/flowable/Integration/IntegrationComponent";

const HaploCostingTool = props => {
	const { onChange, onEvent, config } = props;
	const params = useParams();
	const dictionary = useDictionary("haploCostingIntegration");

	config.value = params.proposalId ?? params.awardId;

	const haploCostingDictionary = useMemo(() => {
		return {
			headline: dictionary?.headline || "Link to Costing Tool Records",
			description: dictionary?.description,
			noData: dictionary?.noData ?? "No Costing Tool records are linked to this SP record. Links can be created from the desired Costing Tool record as applicable.",
			errorMessage: dictionary?.errorMessage,
			infoText: dictionary?.infoText
		}
	}, [ dictionary ]);

	const cardKeys = useMemo(() => {
		return {
			costingID: dictionary?.costingID ?? "Costing ID",
			costingStartDate:  dictionary?.startDate ?? "Start Date",
			costingDurationMonths:  dictionary?.duration ?? "Duration",
			costingLead:  dictionary?.principleInvestigator ?? "Lead PI",
			costingStatus:  dictionary?.status ?? "Status"
		}
	}, [ dictionary ]);

	return (
		<IntegrationComponent
			helper={Helper}
			url={HAPLO_COSTING_API}
			cardKeys={cardKeys}
			dictionary={haploCostingDictionary}
			config={config}
			onChange={onChange}
			onEvent={onEvent}
		/>
	);
};

export default HaploCostingTool;
